<template>
  <div class="text-center">
    <v-dialog v-model="dialog" max-width="870" persistent>
      <v-card>
        <v-card-title class="text-h5 blue darken-4 white--text">
          Detalles del proyecto
          <v-spacer></v-spacer>
          <v-icon dark right @click="dialog = !dialog" :disabled="loading">
            mdi-close
          </v-icon>
        </v-card-title>

        <v-card-text>
          <v-form v-model="valid">
            <v-container>
              <v-row>
                <v-col cols="12" md="12">
                  <v-text-field
                    :counter="250"
                    readonly
                    v-model.trim="xprograma.programa"
                    @input="upper('programa', $event)"
                    label="* proyecto"
                    placeholder="nombre del proyecto"
                    prepend-inner-icon="mdi-bookmark"
                    outlined
                    dense
                    required
                  ></v-text-field>
                </v-col>

                <v-col cols="12" md="6">
                  <v-text-field
                    :counter="25"
                    v-model.trim="xprograma.codigo"
                    @input="upper('codigo', $event)"
                    label="* codigo"
                    placeholder="codigo del programa"
                    prepend-inner-icon="mdi-code-not-equal-variant"
                    color="green"
                    success
                    outlined
                    readonly
                    dense
                    required
                  ></v-text-field>
                </v-col>

                <v-col cols="12" md="6">
                  <v-text-field
                    :counter="4"
                    v-model.number="xprograma.gestion"
                    type="number"
                    label="* gestion"
                    placeholder="gestion"
                    prepend-inner-icon="mdi-calendar-today"
                    outlined
                    readonly
                    dense
                    required
                  ></v-text-field>
                </v-col>

                <v-col cols="12" md="6">
                  <v-text-field
                    :counter="3"
                    v-model="xprograma.version"
                    label="* version"
                    placeholder="version"
                    prepend-inner-icon="mdi-stairs-box"
                    outlined
                    readonly
                    dense
                    required
                  ></v-text-field>
                </v-col>

                <v-col cols="12" md="6">
                  <v-select v-model="xprograma.area" label="* Area" readonly dense outlined :items="areas"></v-select>
                </v-col>
                <v-col cols="12" md="5">
                  <v-menu
                    ref="menu2"
                    v-model="menu2"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    disabled
                    offset-y
                    max-width="290px"
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="dateFormatted2"
                        label="* fecha inicio"
                        persistent-hint
                        prepend-inner-icon="mdi-calendar"
                        outlined
                        readonly
                        dense
                        required
                        v-bind="attrs"
                        @blur="date2 = parseDate(dateFormatted2)"
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker v-model="date2" no-title @input="menu2 = false"></v-date-picker>
                  </v-menu>
                </v-col>

                <v-col cols="12" md="4">
                  <v-menu
                    ref="menu3"
                    v-model="menu3"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    disabled
                    offset-y
                    max-width="290px"
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="dateFormatted3"
                        label="* fecha culminacion"
                        persistent-hint
                        prepend-inner-icon="mdi-calendar"
                        outlined
                        readonly
                        dense
                        required
                        v-bind="attrs"
                        @blur="date3 = parseDate(dateFormatted3)"
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker v-model="date3" no-title @input="menu3 = false"></v-date-picker>
                  </v-menu>
                </v-col>

                <v-col cols="12" md="3">
                  <v-select
                    v-model="xprograma.mes"
                    label="* Mes"
                    item-value="id"
                    readonly
                    dense
                    outlined
                    :items="meses"
                  ></v-select>
                </v-col>

                <v-col cols="12" md="4">
                  <v-select
                    :items="categorias"
                    item-value="id"
                    readonly
                    v-model="xprograma.categoria_id"
                    label="* Categoria"
                    solo
                    messages="Categoria"
                  ></v-select>
                </v-col>

                <v-col cols="12" md="4">
                  <v-select
                    :items="departamentos"
                    item-value="id"
                    readonly
                    v-model="xprograma.departamento_id"
                    label="* Departamento"
                    solo
                    messages="Departamento"
                  ></v-select>
                </v-col>

                <v-col cols="12" md="4">
                  <v-select
                    :items="sedes"
                    item-value="id"
                    readonly
                    v-model="xprograma.sede_id"
                    label="* Sede"
                    solo
                    messages="Sede"
                  ></v-select>
                </v-col>

                <v-col cols="12" md="12" v-if="!xprograma.id">
                  <v-file-input
                    v-model="xdocumento"
                    dense
                    outlined
                    label="* Adjuntar el proyecto (formato word)"
                    placeholder="Seleccionar documento..."
                  ></v-file-input>
                </v-col>
              </v-row>
            </v-container>
          </v-form>

          <v-container v-if="xprograma.id">
            <v-btn tile color="blue" class="mb-2" dark @click="descargardocumento()"
              >Descargar documento del proyecto</v-btn
            >
            <v-progress-linear
              v-if="xversionescreadas == null && !xprograma.version_padre"
              indeterminate
              color="indigo"
            ></v-progress-linear>
            <h3 v-if="xversionescreadas != null && xprograma.version_padre == 0">
              Este proyecto tiene {{ xversionescreadas }} versiones creadas.
            </h3>
          </v-container>

          <v-container class="mt-1" v-if="xprograma.version_padre">
            <hr />
            <p class="ma-0">Esta version se creo a partir del siguiente proyecto:</p>
            <v-progress-linear v-if="!xprogpadre.id" indeterminate color="indigo"></v-progress-linear>
            <p class="mb-0 ml-4"><b class="blue--text">ID: </b> {{ xprogpadre.id }}</p>
            <p class="mb-0 ml-4"><b class="blue--text">Proyecto: </b> {{ xprogpadre.programa }}</p>
            <p class="mb-0 ml-4"><b class="blue--text">Codigo: </b> {{ xprogpadre.codigo }}</p>
            <p class="mb-0 ml-4"><b class="blue--text">Gestion: </b> {{ xprogpadre.gestion }}</p>
            <p class="mb-0 ml-4"><b class="blue--text">Version: </b> {{ xprogpadre.version }}</p>
            <p class="mb-0 ml-4"><b class="blue--text">Area: </b> {{ xprogpadre.area }}</p>
            <p class="mb-0 ml-4"><b class="blue--text">Fecha inicio: </b> {{ xprogpadre.fecha_inicio }}</p>
            <p class="mb-0 ml-4"><b class="blue--text">Fecha culminacion: </b> {{ xprogpadre.fecha_culminacion }}</p>
            <p class="mb-0 ml-4"><b class="blue--text">Mes: </b> {{ xprogpadre.mes }}</p>
          </v-container>

          <p class="text-center red--text">{{ msg }}</p>
          <v-progress-linear v-if="loading || loadingdoc" indeterminate color="indigo"></v-progress-linear>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green" class="darken-2 white--text" tile @click="dialog = !dialog" :disabled="loading">
            <v-icon small lef>
              mdi-close
            </v-icon>
            Cerrar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <div><programautils ref="programautils" /></div>
  </div>
</template>

<script>
  import xaxios from '@/xaxios';
  import programautils from '@/components/AXprogramautils';
  export default {
    data: (vm) => ({
      dialog: false,
      loading: false,
      loadingdoc: false,
      valid: false,
      date: new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().substr(0, 10),
      date2: new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().substr(0, 10),
      date3: new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().substr(0, 10),
      dateFormatted: vm.formatDate(
        new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().substr(0, 10),
      ),
      dateFormatted2: vm.formatDate(
        new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().substr(0, 10),
      ),
      dateFormatted3: vm.formatDate(
        new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().substr(0, 10),
      ),
      menu1: false,
      menu2: false,
      menu3: false,
      msg: '',
      categorias: [],
      departamentos: [],
      sedes: [],
      edit: null,
      xdocumento: null,
      xolddata: { codigo: null, version: null },
      xprograma: {
        id: null,
        codigo: null,
        programa: null,
        gestion: null,
        version: null,
        area: null,
        fecha_inicio: null,
        fecha_culminacion: null,
        categoria_id: null,
        departamento_id: null,
        sede_id: null,
        mes: null,
        version_padre: 1, // es nueva version
      },
      xversionescreadas: null,
      xprogpadre: {},
      xarchivo: {
        Idprograma: null,
        Tipo_documento: null,
        Documento: null,
      },
      meses: [
        { id: 0, text: 'Enero' },
        { id: 1, text: 'Febrero' },
        { id: 2, text: 'Marzo' },
        { id: 3, text: 'Abril' },
        { id: 4, text: 'Mayo' },
        { id: 5, text: 'Junio' },
        { id: 6, text: 'Julio' },
        { id: 7, text: 'Agosto' },
        { id: 8, text: 'Septiembre' },
        { id: 9, text: 'Octubre' },
        { id: 10, text: 'Noviembre' },
        { id: 11, text: 'Diciembre' },
      ],
      areas: ['SALUD', 'EMPRESARIAL', 'LEGAL', 'INGENIERIA', 'SOCIAL'],
    }),
    components: { programautils },
    computed: {
      computedDateFormatted() {
        return this.formatDate(this.date);
      },
    },
    watch: {
      date() {
        this.dateFormatted = this.formatDate(this.date);
      },
      date2() {
        this.dateFormatted2 = this.formatDate(this.date2);
      },
      date3() {
        this.dateFormatted3 = this.formatDate(this.date3);
      },
      xdocumento: function() {
        if (!this.xdocumento) {
          this.xarchivo.Tipo_documento = null;
          this.xarchivo.Documento = null;
          return;
        }
        const vue = this;
        let reader = new FileReader();
        reader.readAsDataURL(this.xdocumento);
        reader.onload = function() {
          vue.xarchivo.Tipo_documento = vue.xdocumento.type;
          vue.xarchivo.Documento = reader.result;
        };
        reader.onerror = function(err) {
          window.console.log('Error:', err);
        };
      },
      'xprograma.version': function() {
        this.generatecode();
      },
      'xprograma.area': function() {
        this.generatecode();
      },
    },
    methods: {
      formatDate(date) {
        if (!date) return null;

        const [year, month, day] = date.split('-');
        return `${day}/${month}/${year}`;
      },
      parseDate(date) {
        if (!date) return null;
        const [day, month, year] = date.split('/');
        return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
      },
      openmodal(editar) {
        this.xprogpadre.id = null;
        this.xversionescreadas = null;
        this.xprograma.version_padre = null;
        this.date = new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().substr(0, 10);
        this.date2 = new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().substr(0, 10);
        this.date3 = new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().substr(0, 10);
        this.dateFormatte = this.formatDate(
          new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().substr(0, 10),
        );
        this.dateFormatted2 = this.formatDate(
          new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().substr(0, 10),
        );
        this.dateFormatted3 = this.formatDate(
          new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().substr(0, 10),
        );

        for (let name in this.xprograma) {
          this.xprograma[name] = null;
        }
        if (editar) {
          this.date2 = editar.fecha_inicio;
          this.date3 = editar.fecha_culminacion;
          this.xprograma.id = editar.id;
          this.xprograma.codigo = editar.codigo;
          this.xprograma.programa = editar.programa;
          this.xprograma.gestion = '' + editar.gestion;
          this.xprograma.version = editar.version;
          this.xprograma.area = editar.area;
          this.xprograma.categoria_id = editar.categoria_id;
          this.xprograma.departamento_id = editar.departamento_id;
          this.xprograma.sede_id = editar.sede_id;
          this.xprograma.mes = editar.mes;
          let o = window.Object.assign({}, editar);
          this.xolddata.codigo = o.codigo;
          this.xolddata.version = o.version;
          this.xprograma.version_padre = editar.version_padre;
          this.getprogramapadre(editar.version_padre);
          this.getprogramaforversioncreadas(editar.id);
        }
        this.edit = editar;
        this.dialog = true;
        this.msg = '';
      },
      getprogramapadre(idpadre) {
        if (!idpadre) return;
        const url = `${process.env.VUE_APP_API_REST}/api/v1/programa-unsxx/${idpadre}`;
        //const url = `http://localhost:8090/api/v1/programa-unsxx/${idpadre}`;
        const vue = this;
        var config = {
          method: 'get',
          url: url,
        };

        xaxios.request(config)
          .then(function(response) {
            vue.xprogpadre = response.data.data;
          })
          .catch(function(error) {
            window.console.log(error);
          });
      },
      getprogramaforversioncreadas(idproy) {
        if (!idproy) return;
        const vue = this;
        const url = `${process.env.VUE_APP_API_REST}/api/v1/programa-unsxx/${idproy}`;
        //const url = `http://localhost:8090/api/v1/programa-unsxx/${idproy}`;
        var config = {
          method: 'get',
          url: url,
        };

        xaxios.request(config)
          .then(function(response) {
            let data = response.data.data;
            vue.xversionescreadas = data.versiones_creadas;
          })
          .catch(function(error) {
            window.console.log(error);
          });
      },
      generatecode() {
        let str = this.xprograma.programa;
        if (!str) str = '';
        str = str.replace(/ +/g, ' ');
        let partes = str.split(' ');
        let code = 'PRY-';
        partes.forEach((x) => {
          if (x.length > 3 && code.length < 18) code += x[0];
        });
        if (this.xprograma.area) {
          let a = this.xprograma.area.substring(0, 2);
          code += `-${a}`;
        }
        if (this.xprograma.version) {
          let c = this.xprograma.version.padStart(3, '0');
          code += `-${c}`;
        }
        this.xprograma.codigo = code;
      },
      upper(v, ev) {
        if (!ev) return;
        this.xprograma[v] = ev.toUpperCase();
      },
      enviar() {
        this.xprograma.fecha_inicio = this.date2;
        this.xprograma.fecha_culminacion = this.date3;

        if (this.xprograma.version < this.xolddata.version) {
          this.msg = 'La version nueva no puede ser menor a la version anterior';
          return;
        }
        if (this.xprograma.codigo == this.xolddata.codigo) {
          this.msg = 'El codigo ya esta asignado en la version anterior, ingrese una version superior';
          return;
        }

        this.msg = 'complete todos los datos del formulario.';
        if (!this.xprograma.codigo) return;
        if (!this.xprograma.programa) return;
        if (!this.xprograma.gestion) return;
        if (!this.xprograma.version) return;
        if (!this.xprograma.area) return;
        if (!this.xprograma.fecha_inicio) return;
        if (!this.xprograma.fecha_culminacion) return;
        if (!this.xprograma.categoria_id) return;
        if (!this.xprograma.departamento_id) return;
        if (!this.xprograma.sede_id) return;
        if (!this.xprograma.mes) return;
        if (!this.xdocumento) {
          this.msg = 'Seleccione un documento del proyecto.';
          return;
        }
        this.xprograma.gestion = '' + this.xprograma.gestion;
        //this.xprograma.nueva_version = 1;
        this.msg = '';

        this.loading = true;
        const vue = this;
        const url = `${process.env.VUE_APP_API_REST}/api/v1/programa-unsxx`;
        //const url = `http://localhost:8090/api/v1/programa-unsxx`;
        let data = this.xprograma;
        window.console.log(JSON.stringify(data, null, 2));
        //let axos = this.xprograma.id ? axios.put(url, data) : axios.post(url, data);
        let axos = xaxios.post(url, data);
        axos
          .then((res) => {
            if (res.data.id) {
              vue.msg = `Registro exitoso: ${res.data.id}`;
              vue.$emit('xnewres', `Registro exitoso: ${res.data.id}`);
              vue.uploaddocumento(res.data.id);
            } else {
              vue.msg = 'No se pudo registrar: ' + res.data;
              vue.loading = false;
            }
          })
          .catch((error) => {
            window.console.error(error);
            vue.msg = error;
            vue.loading = false;
          });
      },
      uploaddocumento(idprograma) {
        this.msg = 'Proyecto registrado, subiendo el documento...';
        this.xarchivo.Idprograma = idprograma;
        const vue = this;

        const url = `${process.env.VUE_APP_API_REST}/api/v1/programasdocs/asignar`;
        //const url = `http://localhost:8090/api/v1/programasdocs/asignar`;
        var config = {
          method: 'post',
          url: url,
          headers: { 'Content-Type': 'application/json' },
          data: this.xarchivo,
        };

        xaxios.request(config)
          .then(function(response) {
            //window.console.log(JSON.stringify(response.data));
            vue.loading = false;
            vue.dialog = false;
            window.console.log('archivo subido id: ', response.data);
          })
          .catch(function(error) {
            window.console.log(error);
            vue.loading = false;
          });
      },
      descargardocumento() {
        this.loadingdoc = true;
        let idp = this.xprograma.id;
        const vue = this;
        const url = `${process.env.VUE_APP_API_REST}/api/v1/programasdocs/get/${idp}`;
        //const url = `http://localhost:8090/api/v1/programasdocs/getbyprograma/${idp}`;
        var config = {
          method: 'get',
          url: url,
          headers: {
            'Content-Type': 'application/json',
          },
        };

        xaxios.request(config)
          .then(function(response) {
            window.console.log(response.data);

            var link = document.createElement('a');
            link.download = vue.xprograma.programa + '.docx';
            link.href = response.data.data.Documento;
            link.click();
            vue.loadingdoc = false;

            /*let arr = response.data.Documento.split(','),
              mime = arr[0].match(/:(.*?);/)[1],
              bstr = atob(arr[1]),
              n = bstr.length,
              u8arr = new Uint8Array(n);

            while (n--) {
              u8arr[n] = bstr.charCodeAt(n);
            }

            let file = new File([u8arr], 'proyecto.docx', { type: mime });
            window.console.log(file);*/
          })
          .catch(function(error) {
            window.console.log(error);
            vue.loadingdoc = false;
          });
      },
    },
    mounted() {
      this.$refs.programautils.getCategorias(this);
      this.$refs.programautils.getDepartamentos(this);
      this.$refs.programautils.getSedes(this);
    },
  };
</script>
